import qs from 'qs'
import axios from '../config/axios.js'
// export const preffixFile = process.env.VUE_APP_FILE_URL
const BASE_URL = '/api/college_manage'
export const UserServer = {
  login: (params) => {
    return axios.post(`${BASE_URL}/auth/login`, qs.stringify(params)).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/server/user.js